import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { HeaderBar } from "../Header";
import { Footer } from "../Footer";
import { useCookies } from 'react-cookie';
import { Box, Drawer, Grid, IconButton, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useContext, useRef, useState } from "react";
import { IoMdMenu, IoIosCloseCircleOutline } from "react-icons/io";
import { MedidasLayOut, themePalette } from "../../config/theme.config";
import { FaHome } from "react-icons/fa";
import { CiLogout } from "react-icons/ci";

import { useAppSelector } from "../../redux/hooks";
import { outUser } from "../../redux/slices/auth.slice";
import { removeCookie } from "typescript-cookie";
import { useDispatch } from "react-redux";

import centro from "../../assets/img/centro.png"
import author from "../../assets/img/author.png"
import unidad from "../../assets/img/unidad.png"

const casConfig = {
    casServer: process.env.REACT_APP_CAS!,
    service: process.env.REACT_APP_FRONT!

}


export const LayoutAuth: React.FC<{}> = () => {
    const [cookie, setCookie, remove] = useCookies();
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [size, setSize] = useState(45);
    const [width, setWidth] = useState("10vw");
    const [topHam, setTopHam] = useState(20);
    const [leftHam, setLeftHam] = useState(10);
    const headerRef = useRef<HTMLDivElement>(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const navigate = useNavigate();
    const theme = useTheme();
    const isXLargeScreen = useMediaQuery(theme.breakpoints.up('xl'));
    const isLargeScreen = useMediaQuery(theme.breakpoints.between('lg', 'xl'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    const isXSmallScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
    const isXSmallDownScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const { isAuth } = useAppSelector((state) => state.authReducer);
    const dispatch = useDispatch();

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
    };

    const GoTo = (site: string) => {
        navigate(site);
    };

    React.useEffect(() => {
        if (isXSmallScreen || isXSmallDownScreen) {
            setSize(25);
            setTopHam(9);
            setLeftHam(5);
            setWidth('20vw');
            setIsDrawerOpen(false);
        } else if (isSmallScreen) {
            setSize(30);
            setTopHam(20);
            setLeftHam(10);
            setWidth('10vw');
            setIsDrawerOpen(false);
        }
        else if (isMediumScreen) {
            setSize(30);
            setTopHam(20);
            setLeftHam(10);
            setWidth('7vw');
        } else if (isLargeScreen) {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth('5vw');
        } else if (isXLargeScreen) {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth('5vw');
        } else {
            setSize(35);
            setTopHam(20);
            setLeftHam(10);
            setWidth(MedidasLayOut.WIDTH_SIDEBAR);
        }
    }, [isXSmallDownScreen, isXSmallScreen, isSmallScreen, isMediumScreen, isLargeScreen, isXLargeScreen]);

    React.useEffect(() => {
        if (headerRef.current) {
            //console.log(headerRef.current.clientHeight);
            if (isXSmallScreen || isXSmallDownScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isSmallScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isMediumScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isLargeScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            } else if (isXLargeScreen) {
                setHeaderHeight(headerRef.current.clientHeight / 9);
            }
        }
    }, [isXSmallDownScreen, isXSmallScreen, isSmallScreen, isMediumScreen, isLargeScreen, isXLargeScreen, headerRef]);

    const logout = () => {
        const logoutUrl = `${casConfig.casServer}/logout?service=${encodeURIComponent(casConfig.service)}`;

        dispatch(outUser());
        
        removeCookie('token');
        window.location.href = logoutUrl;
    };

    return (
        isAuth?
        
            <Box sx={{ minHeight: '100vh' }}>
                <Box ref={headerRef} sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1100 }}>
                    <HeaderBar />
                </Box>
                <Box sx={{ display: 'flex', flex: 1, mt: 4 }}>
                    <Box sx={{
                        borderRadius: '50%',
                        backgroundColor: themePalette.BG_SIDEBAR,
                        position: 'fixed',
                        top: topHam, left: leftHam,
                        zIndex: 1101
                    }}>
                        <IconButton
                            sx={{ color: themePalette.COLOR_SIDEBAR_ICON }}
                            onClick={toggleDrawer}
                        >
                            <IoMdMenu size={25} />
                        </IconButton>
                    </Box>
                    <Drawer
                        variant="persistent"
                        anchor="left"
                        open={isDrawerOpen}
                        onClose={toggleDrawer}
                        sx={{
                            '& .MuiDrawer-paper': {
                                width: width,
                                boxSizing: 'border-box',
                                marginTop: headerHeight, // Ajusta 'marginTop' según la altura del HeaderBar
                                backgroundColor: themePalette.BG_SIDEBAR,
                                position: 'fixed',
                                height: `calc(100% - ${headerHeight}px)`, // Asegúrate de que el Drawer ocupe el espacio restante debajo del HeaderBar
                                top: `${headerHeight}px`,
                            },
                        }}
                    >
                        <Box sx={{ width: width }}>
                            <Grid container
                                direction="column"
                                justifyContent="space-between"
                                alignItems="center"
                                spacing={{ xs: 3, md: 6, lg: 6, xl: 6 }}
                                columns={{ xs: 2, sm: 2, md: 4, lg: 2, xl: 2 }}
                            >
                                <Grid item key={'home-00'}>
                                    <IconButton onClick={() => GoTo('/admin')}>
                                        <FaHome />
                                    </IconButton>
                                </Grid>

                                {/* Contenedor centrado */}
                                <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <img
                                        src={unidad}
                                        alt="Unidad"
                                        style={{ maxWidth: "50%", height: "auto", maxHeight: "100px", cursor: "pointer" }}
                                        onClick={() => GoTo('/admin/unidades')}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <img
                                        src={centro}
                                        alt="Centro"
                                        style={{ maxWidth: "50%", height: "auto", maxHeight: "100px", cursor: "pointer" }}
                                        onClick={() => GoTo('/admin/centros')}
                                    />
                                </Grid>
                                <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    alignItems="center"
                                >
                                    <img
                                        src={author}
                                        alt="Investigador"
                                        style={{ maxWidth: "50%", height: "auto", maxHeight: "100px", cursor: "pointer" }}
                                        onClick={() => GoTo('/admin/investigadores')}
                                    />
                                </Grid>
                                <Grid item>
                                    <IconButton onClick={logout}>
                                        <CiLogout />
                                    </IconButton>
                                </Grid>
                            </Grid>

                        </Box>
                    </Drawer>
                    <Box
                        component="main"
                        sx={{
                            flexGrow: 1,
                            mt: 10,
                            mb: 5,
                            width: 'auto',
                            ml: isDrawerOpen ? `${width}px` : '0',
                            transition: 'margin-left 0.3s',
                        }}
                    >
                        <Outlet />
                    </Box>
                </Box>
                <Footer />
            </Box>
            : <Navigate to='/' />
    );
};
